import React from "react";
import styled from "styled-components";
const StylableYouTube = React.forwardRef((props) => {
    const { media, ...rest } = props;
    return (React.createElement("iframe", { width: "100%", height: "100%", src: `https://www.youtube.com/embed/${media.youtubeId}`, allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true, ...rest }));
});
StylableYouTube.displayName = "StylableYouTube";
StylableYouTube.defaultProps = {
    "data-testid": "mediaYouTubeVideo",
};
export const MediaYouTubeVideo = styled(StylableYouTube) `
  width: 100%;
  height: 100%;
  object-fit: cover;
  border: none;
`;
//# sourceMappingURL=MediaYouTubeVideo.js.map